import MuiBackdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import styled from "styled-components";

// import * as styles from "styles";
import * as Types from "Types";

export type PropsType = any;

const Wrap = styled(MuiBackdrop)<Types.Default>`
   ${({ css }) => css}
`;

// disable, href, variant, disableElevation, color
export default function Backdrop(props: any) {
   const muiProps: any = { sx: { color: "#fff", zIndex: (theme: any) => 1000 }, ...props };

   return (
      <Wrap {...muiProps}>
         <CircularProgress color="inherit" />
      </Wrap>
   );
}
